import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-after-2fa-container',
  styleUrls: ['./after-2fa-container.component.scss'],
  templateUrl: './after-2fa-container.component.html',
  standalone: true,
})
export class After2FaContainerComponent {
  constructor(protected router: Router) {
  }

  ngOnInit(): void {
    // czyścimy ewentualne query paramy ?code=...&session_state=...
    history.replaceState({}, '', window.location.pathname);
    // po 2 sek. wracamy na ekran logowania
    setTimeout(() => this.router.navigateByUrl('/auth/login'), 2000);
  }
}
